import { DeviceChangeHistory } from '../change-info.model';
import * as actions from '../actions/change-info.actions';

export interface ChangeInfoState {
  isLoaded: boolean;
  isLoading: boolean;
  entities: DeviceChangeHistory[];
}

export const initialState: ChangeInfoState = {
  isLoaded: false,
  isLoading: false,
  entities: []
};

export interface UpdateChangeInfoState {
  isLoading: boolean;
  isLoaded: boolean;
  isSaved: boolean;
}

export const initialUpdateChangeInfoState = {
  isLoading: false,
  isLoaded: false,
  isSaved: false
};

export function reducer(state = initialState, action: actions.ChangeInfoActions): ChangeInfoState {
  switch (action.type) {

    case actions.ChangeInfoActionTypes.GET_CHANGE_INFO:
      return {...state, isLoading: true, isLoaded: false };
    case actions.ChangeInfoActionTypes.GET_CHANGE_INFO_SUCCESS:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case actions.ChangeInfoActionTypes.GET_CHANGE_INFO_FAIL:
      return {...state, isLoading: false, isLoaded: true, entities: [] };
    default:
      return state;
  }
}

// export function updateChangeInfoReducer(state: UpdateChangeInfoState = initialUpdateChangeInfoState, action: actions.ChangeInfoActions)
//  : UpdateChangeInfoState {
//   switch (action.type) {
//     case actions.ChangeInfoActionTypes.UPDATE_CHANGE_INFO:
//       return {...state, isLoading: true, isLoaded: false, isSaved: false};
//     case actions.ChangeInfoActionTypes.UPDATE_CHANGE_INFO_SUCCESS:
//       return {...state, isLoading: false, isLoaded: true, isSaved: true};
//     case actions.ChangeInfoActionTypes.UPDATE_CHANGE_INFO_FAIL:
//       return {...state, isLoading: false, isLoaded: true, isSaved: false};
//   }
// }
